// @flow
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Avatar from 'michelangelo/dist/SharedComponents/DataDisplay/Avatar/Avatar'
import Text from 'michelangelo/dist/SharedComponents/Typography/Text'
import color from 'michelangelo/dist/Components/styles/color'
import { injectIntl } from 'react-intl'
import type { InjectIntlProvidedProps } from 'react-intl'
import { messages } from '../i18n/messages'

const ContactsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  max-height: calc(100vh - 215px);
`
ContactsList.displayName = 'ContactsList'

const ContactItem = styled.li`
  display: flex;
  align-items: center;
  padding: 16px;
  background: ${props => props.active ? color.white : color.grey50};
  box-shadow: inset 0px -1px 0px ${color.lightestGrey};
  cursor: ${props => props.active ? 'auto' : 'pointer'};
  @media screen and (max-width: 767.98px) {
    background: ${color.white}
  }
`
ContactItem.displayName = 'ContactItem'

const AvatarContainer = styled.div`
  margin-right: 16px;
`
AvatarContainer.displayName = 'AvatarContainer'

type ContactsProps = {
  items: Array<Object>,
  appBrandColor: string,
  onItemClick?: Function,
  selectedItem?: Object,
  loading?: boolean,
  onLoadMore?: Function
} & InjectIntlProvidedProps

function Contacts (props: ContactsProps) {
  const { items, appBrandColor, onItemClick, selectedItem, loading, intl: { formatMessage }, onLoadMore } = props
  const [selectedContact, setSelectedContact] = useState(selectedItem)

  useEffect(() => {
    const listElm = document.getElementById('contacts-list')
    const onScrollCallback = (e: Object) => {
      if (loading) return
      if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
        onLoadMore()
      }
    }
    if (listElm) {
      listElm.addEventListener('scroll', onScrollCallback)
    }
    return () => {
      if (listElm) {
        listElm.removeEventListener('scroll', onScrollCallback)
      }
    }
  }, [loading, onLoadMore])

  useEffect(() => {
    setSelectedContact(selectedItem)
  }, [selectedItem])

  const onContactClick = (item) => {
    if (selectedContact && (item._id === selectedContact._id)) return
    if (onItemClick) onItemClick(item)
    setSelectedContact(item)
  }

  const isActive = (currentContact) => {
    if (!selectedContact) return false
    return currentContact._id === selectedContact._id
  }
  return (
    <ContactsList id="contacts-list">
      {
        loading ? <Text text={`${formatMessage(messages.loading)}...`} align="center"/> : null
      }
      {
        !loading && items.length === 0 ? <Text text={`${formatMessage(messages.noResults)}!`} align="center"/> : null
      }
      {
        items.map((item, index) => (
          <ContactItem key={index} onClick={() => { onContactClick(item) }} active={isActive(item)}>
            <AvatarContainer>
              <Avatar userName={item.name} size={48} appBrandColor={appBrandColor} thumbnail={item.directoryContactPhoto && item.directoryContactPhoto._128px } />
            </AvatarContainer>
            <Text text={item.name} textSize="p" fontColor={color.lightBlack} />
          </ContactItem>
        ))
      }
    </ContactsList>
  )
}

export default injectIntl(Contacts)
